<template>
  <div class="home-section lab">
    <div class="home-section-inner">
      <div class="head flex flex-center flex-column flex-middle">
        <div class="head-name">入驻实验室推荐</div>
        <div class="head-tips">
          Recommended For Joining The Brand Laboratory
        </div>
      </div>
      <div class="lab-content">
        <el-card
          shadow="always"
          v-for="(item, index) in labs"
          :key="index"
          class="lab-item pointer"
          @click.native="toLabDetail(item)"
        >
          <div class="lab-logo">
            <img
              v-if="item.laboratoryLogo"
              :src="item.laboratoryLogo"
              :alt="item.laboratoryName"
              :title="item.laboratoryName"
            />
            <img
              v-else
              :src="$oss('common/empty-img.png')"
              :alt="item.laboratoryName"
              :title="item.laboratoryName"
            />
          </div>
          <!-- <div class="ellipsis lab-name">{{ item.laboratoryName }}</div> -->
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { hotLab } from "@/api/home";
export default {
  name: "modular_laboratory",
  components: {},
  data() {
    return {
      labs: [],
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getLabs();
  },
  methods: {
    toLabDetail({ laboratoryId }) {
      this.$jump.push({ name: "labDetail", query: { id: laboratoryId } });
    },
    async getLabs() {
      const { list } = await this.$axios.get(hotLab, this.page);
      this.labs = list;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.lab {
  &-content {
    display: grid;
    grid-template-columns: repeat(5, calc(20% - 8px));
    gap: 10px;
  }
  &-item {
    margin: 0px 10px 10px 0;
  }
  &-logo {
    width: 100%;
    height: 50px;
    margin-bottom: 10px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &-name {
    text-align: center;
    width: 100%;
  }
}
</style>
